export enum CommonMediaQueries {
  XS = 320,
  SM = 375,
  MD = 768,
  L = 991,
  XL = 1366,
  XXL = 1920,
}
